export const FileCheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 9.91666V5.16666C14.6666 3.76653 14.6666 3.06646 14.3941 2.53168C14.1544 2.06128 13.772 1.67882 13.3016 1.43914C12.7668 1.16666 12.0667 1.16666 10.6666 1.16666H5.33325C3.93312 1.16666 3.23306 1.16666 2.69828 1.43914C2.22787 1.67882 1.84542 2.06128 1.60574 2.53168C1.33325 3.06646 1.33325 3.76653 1.33325 5.16666V13.8333C1.33325 15.2335 1.33325 15.9335 1.60574 16.4683C1.84542 16.9387 2.22787 17.3212 2.69828 17.5608C3.23306 17.8333 3.93312 17.8333 5.33325 17.8333H7.99992M9.66659 8.66666H4.66659M6.33325 12H4.66659M11.3333 5.33332H4.66659M10.0833 15.3333L11.7499 17L15.4999 13.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
